import { configureStore } from "@reduxjs/toolkit";
// ...
import addAnswerReducer from './slices/addAnswerSlice'
import addCertificateReducer from './slices/addCertificateSlice'
import addCourseReducer from './slices/AddCourseSlice'
import addFormationReducer from './slices/addFormationSlice'
import addQuestionReducer from './slices/AddQuestionSlice'
import addRessourceReducer from './slices/addRessourceSlice'
import addTestReducer from './slices/AddTestSlice'
import answersReducer from './slices/answersSlice'
import certificateReducer from './slices/certificateSlice'
import coursesReducer from './slices/coursesSlice'
import currentCourseReducer from './slices/currentCourseSlice'
import currentFormationReducer from './slices/currentFormationSlice'
import currentTestReducer from './slices/currentTestSlice'
import enrolledFormationsReducer from './slices/enrolledFormationsSlice'
import formationsReducer from './slices/formationsSlice'
import passTestReducer from './slices/passTestSlice'
import questionsReducer from './slices/questionsSlice'
import ressourcesReducer from './slices/ressourcesSlice'
import testsReducer from './slices/testsSlice'
import updateFormationReducer from './slices/updateFormationSlice'
import userAnswersReducer from './slices/userAnswersSlice'
import userReducer from './slices/userSlice'
import usersReducer from './slices/usersSlice'
export const store = configureStore({
  reducer: {
    user: userReducer,
    addCourse: addCourseReducer,
    courses: coursesReducer,
    addRessource: addRessourceReducer,
    addTest: addTestReducer,
    addQuestion: addQuestionReducer,
    addAnswer: addAnswerReducer,
    questions: questionsReducer,
    answers: answersReducer,
    tests: testsReducer,
    formations: formationsReducer,
    ressources: ressourcesReducer,
    users: usersReducer,
    addFormation: addFormationReducer,
    currentFormation: currentFormationReducer,
    currentCourse: currentCourseReducer,
    currentTest: currentTestReducer,
    enrolledFormations: enrolledFormationsReducer,
    updateFormation: updateFormationReducer,
    userAnswers: userAnswersReducer,
    addCertificate: addCertificateReducer,
    certificate: certificateReducer,
    passTest: passTestReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
